import styled from "styled-components";

export const ButtonContainer = styled.button`
    margin: 0 10px;
    cursor: pointer;
    text-decoration: none;
    color: ${({ theme }) => theme.text1};
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border-radius: 1.5rem;
    border: 2px solid ${({ theme }) => theme.yetiBlue};
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex: 1;
    background-color: transparent;
    width: 100%;
    user-select: none;
  
    &:hover {
        transform: scale(1.01);
        box-shadow: ${({ theme }) => theme.boxShadow};
    }
  
    &.loading,
    &.disabled{
        border: 2px solid ${({ theme }) => theme.bg4};
        color: ${({ theme }) => theme.text3};
        &:hover {
            transform: unset !important;
            box-shadow: unset;
            cursor: not-allowed;
        }
    }

    > svg {
        margin-right: 10px;
    }

    &.solid {
        border: 2px solid ${({ theme }) => theme.newBg1};
        background-color: ${({ theme }) => theme.newBg1};
        color: #fff;
    }
`
